import type { FC } from 'react';

import { Form } from '../../Form.tsx';
import type { GenericFormProps } from '../../GenericFormProps.ts';
import { CoverImage } from './CoverImage.tsx';
import { schema } from './schema.ts';

export const CoverImageForm: FC<GenericFormProps<typeof CoverImage, typeof schema>> = ({
  onSubmit,
  buttonSlot,
  defaultValues,
}) => (
  <Form
    buttonSlot={buttonSlot}
    defaultValues={defaultValues}
    formContentElement={CoverImage}
    schema={schema}
    onSubmit={onSubmit}
  />
);
